import { render } from "./Foota.vue?vue&type=template&id=3a2a4e32&scoped=true"
const script = {}

import "./Foota.vue?vue&type=style&index=0&id=3a2a4e32&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Zayd\\Documents\\Web Development\\Clients Projects\\RHDesigns\\rhdesigns-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2a4e32"]])

export default __exports__